import React from "react";

import Head from "next/head";
import PropTypes from "prop-types";

import toSchema from "../../helpers/toSchema/toSchema";

function JobStructuredData(props) {
  const { vacancy } = props;

  return (
    <Head>
      <script
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(toSchema(vacancy)),
        }}
        type="application/ld+json"
      />
    </Head>
  );
}

export default JobStructuredData;

JobStructuredData.propTypes = {
  vacancy: PropTypes.shape().isRequired,
};
